import TransactionCategoryCreate from "@/controllers/transaction_category/transaction-category-create.js";

export default {
    extends: TransactionCategoryCreate,
};
